import React, { useState, useEffect } from "react";
// import { FaCheckCircle } from "react-icons/fa";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { RxCrossCircled } from "react-icons/rx";
import { FaArrowRight } from "react-icons/fa";
import Section from "../Section";
import { FaFilter } from "react-icons/fa";
import { FaCheck, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { API_URL } from "../../Config/environment";

const Membershipplan = () => {
    const ITEMPERPAGE = 2000;
    const [memberships, setMemberships] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [allFeatureList, setAllFeatureList] = useState([]);
    const [allMembeshipData, setAllMembeshipData] = useState([]);
    const [filter, setFilter] = useState("");

    const fetchFeatures = async (page) => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(
                `${API_URL}/membership/feature?page=${page}&limit=3000`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            setLastPage(data?.data?.lastPage);
            setAllFeatureList(data?.data?.features);
        } catch (error) {
            console.error("Error fetching features", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchMembershipRecord = async (page, selectedCategory) => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(
                `${API_URL}/user/membership/plan?category=${selectedCategory}&page=${page}&limit=${ITEMPERPAGE}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            setLastPage(data?.data?.lastPage);
            setAllMembeshipData(data?.data?.membership_plans);
        } catch (error) {
            console.error("Error fetching membership plans", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFeatures(1);
        fetchMembershipRecord(currentPage, filter);
    }, [filter]);

    const filteredPackages =
        filter === ""
            ? allMembeshipData
            : allMembeshipData.filter((p) => p.category === filter);

    const normalizedFeatureMaps = React.useMemo(() => {
        return filteredPackages.map((plan) => {
            const map = {};
            Object.entries(plan.features || {}).forEach(([k, v]) => {
                map[k.trim().toLowerCase()] = v;
            });
            return { id: plan.id, normalized: map };
        });
    }, [filteredPackages]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <Section
            topMd={185}
            topLg={140}
            topXl={100}
            bottomMd={185}
            bottomLg={140}
            bottomXl={100}
        >
            {/* Filter Dropdown in top-right */}
            <div className="d-flex justify-content-end mb-4">
                <select
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className="form-select w-auto rounded-pill"
                >
                    <option value="">All</option>
                    <option value="NATIONAL">National</option>
                    <option value="INTERNATIONAL">International</option>
                </select>
            </div>

            {/* Cards */}
            <div className="row g-4 justify-content-center">
                {filteredPackages.map((pack) => {
                    const discountPercent = Math.round(
                        ((pack.price - pack.discountPrice) / pack.price) * 100
                    );

                    return (
                        <div
                            key={pack.id}
                            className="col-auto d-flex justify-content-center"
                        >
                            <div className="pricing-card">
                                {/* Image Section */}
                                <div className="pricing-card__image-wrapper">
                                    {/* <img
              src="/images/healthBa.jpg"
              alt={pack.name}
              className="pricing-card__image"
            /> */}
                                    {/* <span className="pricing-card__badge category">{pack.category}</span> */}
                                    {/* <span className="pricing-card__badge discount">{discountPercent}% OFF</span> */}
                                </div>

                                {/* Card Content */}
                                <div className="pricing-card__content">
                                    {/* Price */}
                                    <span className="pricing-card__price">
                                        ₹{pack.discountPrice}{" "}
                                        <small>/ plan</small>
                                    </span>

                                    {/* Plan Name & Description */}
                                    <p className="pricing-card__title">
                                        {pack.name}
                                    </p>
                                    <p className="pricing-card__description">
                                        {pack.description}
                                    </p>

                                    {/* Features */}
                                    <ul className="pricing-card__features">
                                        {Object.entries(pack.features).map(
                                            ([feature, has]) => (
                                                <li key={feature}>
                                                    {has ? (
                                                        <IoCheckmarkCircleOutline className="icon" />
                                                    ) : (
                                                        <RxCrossCircled className="icon cross" />
                                                    )}
                                                    <span>{feature}</span>
                                                </li>
                                            )
                                        )}
                                    </ul>

                                    {/* CTA */}
                                    <div className="pricing-card__action">
                                        <Link
                                            to={
                                                "https://app.gkcklinica.com/login?membership=true"
                                            }
                                            className="btn-choose"
                                        >
                                            Buy Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="comparison-wrapper">
                <div className="table-responsive">
                    <table className="table table-bordered membership-table align-middle text-center mb-0">
                        <thead className="table-light table-header">
                            <tr>
                                <th className="feature-col text-start">
                                    Features
                                </th>
                                {filteredPackages.map((plan, i) => (
                                    <th
                                        key={plan.id || i}
                                        className={`plan-col blue${i + 1
                                            } text-center align-middle`}
                                    >
                                        <h3 className="h6 fw-semibold mb-0">
                                            {plan.name || plan.description}
                                        </h3>
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {allFeatureList.map((feature, i) => {
                                const featureName = feature?.name
                                    ? feature.name
                                    : String(feature);
                                const normalizedFeatureKey = featureName
                                    .trim()
                                    .toLowerCase();

                                return (
                                    <tr className="table-row" key={i}>
                                        <td className="feature-col text-start fw-medium">
                                            {featureName}
                                        </td>

                                        {filteredPackages.map((plan, j) => {
                                            const planMap =
                                                normalizedFeatureMaps.find(
                                                    (p) => p.id === plan.id
                                                )?.normalized;

                                            const hasFeature =
                                                planMap?.[
                                                normalizedFeatureKey
                                                ] ??
                                                plan.features?.[featureName] ??
                                                false;

                                            return (
                                                <td
                                                    key={plan.id || j}
                                                    className="plan-col align-middle"
                                                    aria-label={`${plan.name ||
                                                        plan.description
                                                        } - ${featureName}`}
                                                >
                                                    {hasFeature ? (
                                                        <FaCheck className="icon text-success fs-5" />
                                                    ) : (
                                                        <FaTimes className="icon text-danger fs-5" />
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>

                        {/* <tfoot className="table-footer">
                            <tr>
                                <td className="feature-col"></td>
                                {filteredPackages.map((plan, i) => (
                                    <td
                                        key={plan.id || i}
                                        className="plan-col text-center align-middle"
                                    >
                                        <Link
                                            to="https://app.gkcklinica.com/login?membership=true"
                                            className={`btn ${
                                                plan.price === "Free"
                                                    ? "btn-danger"
                                                    : "btn-primary"
                                            }`}
                                        >
                                            {plan.price === "Free"
                                                ? "Get Started"
                                                : "Buy Now"}
                                        </Link>
                                    </td>
                                ))}
                            </tr>
                        </tfoot> */}
                    </table>
                </div>
            </div>
        </Section>
    );
};

export default Membershipplan;
